<template>
    <div class="branding-section">
        <v-form ref="form" lazy-validation>
            <!-- style="border: 2px solid" -->

            <v-row class="mt-5">
                <v-col>
                    <div class="d-flex justify-center">
                        <div>
                            <h5 class="text-center">Primary Color</h5>

                            <v-color-picker
                                width="250px"
                                v-model="videoPlayerPrimaryColor"
                                elevation="2"
                                mode="hexa"
                                style="padding-bottom: 26px"
                            ></v-color-picker>
                        </div>
                    </div>
                </v-col>
                <v-col>
                    <div class="d-flex justify-center">
                        <div>
                            <h5 class="text-center">Secondary Color</h5>
                            <v-color-picker
                                width="250px"
                                v-model="videoPlayerSecondaryColor"
                                elevation="2"
                                mode="hexa"
                                style="padding-bottom: 26px"
                            ></v-color-picker>
                        </div>
                    </div>
                </v-col>

                <v-col class="d-flex justify-center">
                    <div>
                        <h5 class="text-center">Logo</h5>
                        <v-card
                            class="m-0 pt-3"
                            style="width: 250px; display: flex; justify-content: center"
                            width="250px"
                            elevation="2"
                        >
                            <logo-upload
                                class="logoUpload"
                                :funeralHomeId="id"
                                @refresh="handleRefresh()"
                                @logo-not-ready="logoNotReady()"
                                @logo-is-ready="logoIsReady()"
                            ></logo-upload>
                        </v-card>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-8"></v-divider>

            <v-row class="justify-center">
                <v-col style="max-width: 400px">
                    <div v-if="logo">
                        <h5 class="text-center">Logo Size</h5>
                        <v-slider v-model="logoSize" min="0" max="30"></v-slider>
                    </div>
                </v-col>
            </v-row>

            <v-row class="justify-center pb-5">
                <v-col>
                    <div
                        style="aspect-ration: 16/9"
                        class="d-flex flex-column align-items-center justify-content-center"
                    >
                        <custom-tooltip :tooltipProps="{ top: true }">
                            <template v-slot:activator>
                                <h3>Upcoming</h3>
                            </template>

                            <template v-slot:content>
                                <span>This will be visible when a live stream is scheduled.</span>
                            </template>
                        </custom-tooltip>

                        <div class="upcoming-preview">
                            <div style="width: 100%" class="p-2">
                                <!-- <p style="color: white">test</p> -->
                                <v-text-field
                                    class="text-center centered-input"
                                    dark
                                    v-model="videoPlayerHeading"
                                ></v-text-field>
                            </div>
                            <div style="color: white">
                                <p class="mb-0">
                                    {{ $moment(new Date()).add(3, 'days').format('MMMM Do, YYYY') }} - 1:00 pm
                                </p>

                                <div class="text-center awaiting-event-entry">
                                    <span> Visitation </span>
                                    <span class="live-chip"> • Live </span>
                                </div>
                            </div>

                            <img v-if="logo" class="upcoming-logo" :src="logo" alt="logo" />
                        </div>
                    </div>
                </v-col>
                <v-col>
                    <div
                        style="aspect-ration: 16/9"
                        class="d-flex flex-column align-items-center justify-content-center"
                    >
                        <custom-tooltip :tooltipProps="{ top: true }">
                            <template v-slot:activator>
                                <h3>Video Player</h3>
                            </template>

                            <template v-slot:content>
                                <span>This will be visible when a video is available to watch.</span>
                            </template>
                        </custom-tooltip>

                        <div style="width: 480px">
                            <branding-player-preview
                                ref="brandingPlayerPreview"
                                :videoPlayerPrimaryColor="videoPlayerPrimaryColor"
                                :videoPlayerSecondaryColor="videoPlayerSecondaryColor"
                                :logo="logo"
                                :logoSize="logoSize"
                                :source="source"
                                :logoReady="logoReady"
                                :poster="poster"
                            ></branding-player-preview>
                        </div>
                    </div>
                    <div class="d-flex justify-center">
                        <v-switch inset label="Display Thumbnail" v-model="displayThumbnail"></v-switch>
                    </div>
                </v-col>
            </v-row>
        </v-form>

        <!-- <v-form ref="form" class="mt-8" lazy-validation> -->

        <v-row v-if="tab != 'tribute'">
            <v-col class="text-right">
                <v-btn :loading="loading" :disabled="loading" color="primary" @click="saveSettings"> Save </v-btn>
            </v-col>
        </v-row>
        <!-- </v-form> -->

        <media-uploader
            ref="videoUpload"
            :token="token"
            :uploaderType="MEDIA_UPLOADER_TYPES.TRIBUTE_VIDEO_ENDING_VIDEO"
            :itemId="parseInt(this.$auth.role.includes('FuneralHome') ? this.$auth.funeralHomeId : this.id)"
            :allowedFileTypes="['.mp4', '.mov']"
            @refresh="getSettings"
        />
    </div>
</template>

<script>
import { mapActions } from 'pinia';
import LogoUpload from '@/components/Misc/LogoUpload.vue';
import BrandingPlayerPreview from '@/components/videojs/BrandingPlayerPreview.vue';
import BrandingPlayerThumbnail from '@/assets/images/branding-preview-thumbnail.jpg';
import SampleLetters from '@/assets/images/alex-brush-letters.png';
import MediaUploader from '@/components/ui/MediaUploader.vue';
import CustomTooltip from '@/components/ui/CustomTooltip.vue';
import { MEDIA_UPLOADER_TYPES } from '@/constants';
import { useGlobalState } from '@/stores/globalState';

export default {
    data() {
        return {
            MEDIA_UPLOADER_TYPES,
            editColors: false,
            options: '',
            refreshKey: 9,
            message: 'branding',
            videoPlayerPrimaryColor: '',
            videoPlayerSecondaryColor: '',
            logo: '',
            logoSize: 0,
            source: 'https://memoryshareprod.blob.core.windows.net/front-end-assets/BrandingSampleVideo.mp4',
            poster: '',
            logoReady: true,
            tributeEndingBackgroundImage: '',
            tributeEndingShowLogo: false,
            sampleLetters: SampleLetters,
            tributeEndingVideo: '',
            tributeVideosEnabled: false,
            loading: true,
            tab: 'stream',
            videoPlayerHeading: '',
            displayThumbnail: false,
            sampleThumbnail: BrandingPlayerThumbnail,
            blankThumbnail: process.env.VUE_APP_AZURE_BASE_DOMAIN + '/front-end-assets/video_poster_placeholder.png',
        };
    },
    components: {
        LogoUpload,
        BrandingPlayerPreview,
        BrandingPlayerThumbnail,
        MediaUploader,
        SampleLetters,
        CustomTooltip,
    },
    props: ['id', 'token', 'homeId', 'isActive'],
    async mounted() {
        await this.getSettings();
    },
    watch: {
        tributeEndingShowLogo() {
            if (!this.loading) {
                this.updateShowLogo();
            }
        },
        displayThumbnail() {
            if (this.displayThumbnail) {
                this.poster = this.sampleThumbnail;
            } else {
                this.poster = this.blankThumbnail;
            }
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),

        deleteEndingBackgroundImage() {
            let id = this.$auth.role.includes('FuneralHome') ? this.$auth.funeralHomeId : this.id;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .delete(process.env.VUE_APP_API + `/funeralhomes/tribute-ending-bg/${id}`)
                .then(response => {
                    (this.tributeEndingBackgroundImage = ''),
                        this.showSnackbar({ message: 'Settings successfuly updated' });
                })
                .catch(error => {
                    this.showSnackbar({ message: 'Error! Settings not updated' });
                    console.log(error);
                });
        },
        deleteEndingVideo() {
            let id = this.$auth.role.includes('FuneralHome') ? this.$auth.funeralHomeId : this.id;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .delete(process.env.VUE_APP_API + `/funeralhomes/tribute-ending-video/${id}`)
                .then(response => {
                    this.tributeEndingVideo = '';
                    this.refreshKey++;
                    this.saveSettings();
                    this.showSnackbar({ message: 'Settings successfuly updated' });
                })
                .catch(error => {
                    this.showSnackbar({ message: 'Error! Settings not updated' });
                    console.log(error);
                });
        },
        imgUploadInit() {
            this.$refs.imgUpload.handleOpen();
        },
        videoUploadInit() {
            this.$refs.videoUpload.handleOpen();
        },
        logoIsReady() {
            this.logoReady = true;
        },
        logoNotReady() {
            this.logoReady = false;
        },
        handleRefresh() {
            this.logo = '';
            this.logoSize = 10;
            this.getSettings();
        },
        toggleEditColors() {
            this.editColors = !this.editColors;
        },
        updateShowLogo() {
            let data = {
                tributeEndingShowLogo: this.tributeEndingShowLogo,
            };

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .put(
                    process.env.VUE_APP_API + `/funeralhomes/settings/branding/update-show-logo-tribute/${this.id}`,
                    data,
                )
                .then(response => {})
                .catch(error => {
                    // this.showSnackbar({ message: 'Error! Settings not updated' });
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        saveSettings() {
            let valid = this.$refs.form.validate();

            if (valid) {
                this.loading = true;

                let data = {
                    videoPlayerPrimaryColor: this.videoPlayerPrimaryColor,
                    videoPlayerSecondaryColor: this.videoPlayerSecondaryColor,
                    videoPlayerLogoSize: this.logoSize,
                    logoPath: this.logo,
                    tributeEndingShowLogo: this.tributeEndingShowLogo,
                    videoPlayerHeading: this.videoPlayerHeading,
                    displayThumbnail: this.displayThumbnail,
                };

                if (!this.$auth.role.includes('FuneralHome')) {
                    this.axios
                        .create({ headers: { Authorization: `Bearer ${this.token}` } })
                        .put(process.env.VUE_APP_API + `/funeralhomes/settings/branding/${this.id}`, data)
                        .then(response => {
                            this.showSnackbar({ message: 'Settings successfuly updated' });
                        })
                        .catch(error => {
                            this.showSnackbar({ message: 'Error! Settings not updated' });
                            console.log(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (this.$auth.role.includes('FuneralHome')) {
                    this.axios
                        .create({ headers: { Authorization: `Bearer ${this.token}` } })
                        .put(
                            process.env.VUE_APP_API + `/funeralhomes/settings/branding/${this.$auth.funeralHomeId}`,
                            data,
                        )
                        .then(response => {
                            this.showSnackbar({ message: 'Settings successfuly updated' });
                        })
                        .catch(error => {
                            this.showSnackbar({ message: 'Error! Settings not updated' });
                            console.log(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
        getSettings() {
            if (!this.$auth.role.includes('FuneralHome')) {
                this.loading = true;
                return this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .get(process.env.VUE_APP_API + `/funeralhomes/settings/branding/${this.id}`)
                    .then(response => {
                        let data = response.data;

                        if (response.data) {
                            this.logo = data.logoPath;
                            this.logoSize = data.videoPlayerLogoSize ? data.videoPlayerLogoSize : 10;
                            this.videoPlayerPrimaryColor = data.videoPlayerPrimaryColor
                                ? data.videoPlayerPrimaryColor
                                : '#ab0658';
                            this.videoPlayerSecondaryColor = data.videoPlayerSecondaryColor
                                ? data.videoPlayerSecondaryColor
                                : '#ffffff';
                            this.tributeEndingBackgroundImage = data.tributeEndingBackgroundImage;
                            this.tributeEndingVideo = data.tributeEndingVideo;
                            this.tributeEndingShowLogo = data.tributeEndingShowLogo;
                            this.tributeVideosEnabled = data.tributeVideos;
                            this.videoPlayerHeading = data.videoPlayerHeading;
                            this.displayThumbnail = data.displayThumbnail;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.$emit('message', error.response.data);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.loading = true;
                return this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .get(process.env.VUE_APP_API + `/funeralhomes/settings/branding/${this.$auth.funeralHomeId}`)
                    .then(response => {
                        let data = response.data;

                        if (response.data) {
                            this.logo = data.logoPath;
                            this.logoSize = data.videoPlayerLogoSize ? data.videoPlayerLogoSize : 10;
                            this.videoPlayerPrimaryColor = data.videoPlayerPrimaryColor
                                ? data.videoPlayerPrimaryColor
                                : '#ab0658';
                            this.videoPlayerSecondaryColor = data.videoPlayerSecondaryColor
                                ? data.videoPlayerSecondaryColor
                                : '#ffffff';

                            this.tributeEndingBackgroundImage = data.tributeEndingBackgroundImage;
                            this.tributeEndingVideo = data.tributeEndingVideo;
                            this.tributeEndingShowLogo = data.tributeEndingShowLogo;
                            this.tributeVideosEnabled = data.tributeVideos;
                            this.videoPlayerHeading = data.videoPlayerHeading;
                        }
                    })
                    .catch(error => {
                        console.log(error);

                        this.showSnackbar({ message: 'Error retreiving settings' });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss">
.branding-section {
    .hide-tabs .v-tabs-bar {
        display: none !important;
    }

    .hide-logo-btn {
        opacity: 0;
        color: white;
        transition: 0.2s;
    }

    .show-logo-btn {
        transition: 0.2s;
        color: rgba(255, 255, 255, 0.65);
    }
    .show-logo-btn:hover {
        color: white;
    }

    .hide-logo-btn:hover {
        color: #ff5252;
    }
    .logo-overlay:hover .hide-logo-btn {
        opacity: 1;
    }

    .awaiting-event-entry {
        font-weight: 300;
        font-size: 1rem;
        margin: 0;
        display: flex;
        gap: 0.75rem;
        align-items: center;
        justify-content: center;
        flex-direction: row-reverse;
    }
    .live-chip {
        background: #df2000;
        border-radius: 5px;
        padding: 0 0.2rem;
        font-size: 0.7rem;
        color: #fff;
        font-weight: bold;
    }
    .centered-input .v-input__slot {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .upcoming-logo {
        width: var(--custom-logo-width);
        position: absolute;
        right: 5px;
        bottom: 5px;
        max-width: 400px;
        z-index: 2;
    }

    .upcoming-preview {
        height: 100%;
        border-radius: 5px;
        background-color: #333;
        width: 480px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        aspect-ratio: 16/9;
        position: relative;
    }

    .logoUpload {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 250px;
        height: 304px;
    }

    .ending-selection {
        /* border: 2px solid #d8d8d8; */
        padding: 10px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        border: 2px solid transparent;
        transition: 0.3s;
    }
    .ending-selection:hover {
        border: 2px solid #d8d8d8;
    }

    .active-ending {
        border: 2px solid #1976d2 !important;
        background-color: hsla(211, 80%, 86%, 0.376);
    }

    .image-main-container {
        position: relative;
        width: 100%;
        max-width: 480px;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-grow: 2;
        aspect-ratio: 16/9;
    }

    .main-bg-img {
        border-radius: 5px;
        aspect-ratio: 16/9;
    }

    .image-dark-background {
        border-radius: 5px;
        position: absolute;
        top: 0;
        width: 100%;
        background-color: black;
        display: flex;
        flex-grow: 1;
        aspect-ratio: 16/9;
    }

    .life-span {
        font-size: 1rem;
        position: absolute;
        top: 70%;
        width: 100%;
        text-align: center;
        color: white;
        z-index: 4;
    }

    .content-wrapper {
        width: 100%;
        max-width: 550px;
        aspect-ratio: 16/9;
        position: relative;
        background-color: $light-gray;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .logo-overlay {
        width: var(--custom-logo-width);
        position: absolute;
        right: 5px;
        bottom: 5px;
        max-width: 400px;
        z-index: 5;
    }

    .ending-video {
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        aspect-ratio: 16/9;
        max-width: 100%;
        object-fit: cover;
        border-radius: 5px;
        margin: 0;
        padding: 0;
    }
}
</style>
